import { render, staticRenderFns } from "./ContactRequestList.vue?vue&type=template&id=65dd468a"
import script from "./ContactRequestList.vue?vue&type=script&lang=js"
export * from "./ContactRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports